import { useEffect } from 'react';

const RELOAD_THRESHOLD = 3 * 60 * 60 * 1000; // 3 hours
let _test_handleVisibilityChange: (() => void) | undefined;

/**
 * This hook automatically reloads the page when it's inactive for 3 hours.
 * This is useful for preventing the page from showing stale data when the user is idle.
 */
const useAutoReloadWhenInactive = () => {
  useEffect(() => {
    const LAST_ACTIVE_KEY_MS = 'lastActiveTime';

    const updateLastActiveTime = () => {
      localStorage.setItem(LAST_ACTIVE_KEY_MS, Date.now().toString());
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const lastActive = parseInt(localStorage.getItem(LAST_ACTIVE_KEY_MS) || '0', 10);
        const now = Date.now();
        if (now - lastActive > RELOAD_THRESHOLD) {
          window.location.reload();
        } else {
          updateLastActiveTime();
        }
      }
    };
    // Expose for test
    if (process.env.NODE_ENV === 'test') {
      _test_handleVisibilityChange = handleVisibilityChange;
    }

    window.addEventListener('visibilitychange', handleVisibilityChange);
    if (document.visibilityState === 'visible') {
      updateLastActiveTime();
    }

    return () => {
      window.removeEventListener('visibilitychange', handleVisibilityChange);
      if (process.env.NODE_ENV === 'test') {
        _test_handleVisibilityChange = undefined;
      }
    };
  }, []);
};

export default useAutoReloadWhenInactive;
export { _test_handleVisibilityChange };
